<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Подключение к&nbsp;Telegram</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="kak-popast"
            class="typography__headline2"
          >
            Как попасть
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Давайте подключим вашего бота в&nbsp;Telegram к&nbsp;MyDonut.</p>

            <p>В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Бот&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/podklyuchenie-k-telegram-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="podklyuchenie-k-telegram"
            class="typography__headline2"
          >
            Подключение к Telegram
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              На&nbsp;открывшейся странице нажмите &laquo;Подключить&raquo; в&nbsp;блоке посередине или выберите
              с&nbsp;меню слева раздел Telegram.
            </p>

            <p>
              Пока интеграция доступна только с&nbsp;Telegram. В&nbsp;разработке находится подключение к&nbsp;Instagram,
              Snapchat и&nbsp;Facebook Messenger.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/podklyuchenie-k-telegram-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>Следуйте инструкции, вставьте токен и&nbsp;нажмите &laquo;Подключить ваш бот&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/podklyuchenie-k-telegram-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>Как это выглядит в&nbsp;Telegram в&nbsp;чате с&nbsp;BotFather.</p>

            <p>Сначала вводим команду /newbot.</p>

            <p>Затем пишем название бота.</p>

            <p>В&nbsp;конце указываем как будет писаться ссылка (название аккаунта) на&nbsp;бота.</p>

            <p>
              После успешного завершения, нужно будет скопировать токен и&nbsp;вставить его в&nbsp;инпут на&nbsp;форме
              подключения.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/podklyuchenie-k-telegram-4.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            После успешного подключения вы&nbsp;увидите уведомление и&nbsp;домашнюю страницу раздела с&nbsp;настройкой
            Telegram-бота.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/podklyuchenie-k-telegram-5.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <FaqArticlesImageModalButton
            image-source="/images/faq/podklyuchenie-k-telegram-6.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Как подключиться к Telegram разобрались. Самое время перейти к
            <BaseLink
              class="ui-link-secondary"
              to="/faq/articles/konstruktor-bota"
              >конструктору бота</BaseLink
            >.
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Бот и&nbsp;интеграции",
    url: "/faq/categories/bot-i-integratsii",
  },
  {
    name: "Подключение к&nbsp;Telegram",
  },
];

const menu = [
  {
    name: "Как&nbsp;попасть",
    url: "kak-popast",
  },
  {
    name: "Подключение&nbsp;к&nbsp;Telegram",
    url: "podklyuchenie-k-telegram",
  },
];

const relatedArticles = [
  {
    name: "Бот для клиентов",
    slug: "bot-dlya-klientov",
  },
  {
    name: "Конструктор бота",
    slug: "konstruktor-bota",
  },
  {
    name: "Уведомления клиента",
    slug: "uvedomleniya-klienta",
  },
];

useSeoMeta({
  title: "Подключение к Telegram",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
